import * as AT from '../action/actionTypes';


const initialState = {
    isShow: false,
    typeMsg: 'success',
    msg: ''
}


const snackbarReducer = (state = initialState, action) => {

    switch (action.type) {
        case AT.SET_SNACKBAR:
            return {
                ...state,
                isShow: action.isShow,
                typeMsg:action.typeMsg,
                msg:action.msg
            }
        default:
            return {
                ...state
              }
    }
}

export default snackbarReducer